<template>
  <v-dialog v-model="dialog" max-width="400">
    <template #activator="{ on }">
      <v-btn outlined small v-on="on" color="#FF347C">
        Edit Password <v-icon right> mdi-lock-outline </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title> Edit user password </v-card-title>
      <v-card-text class="text--primary">
        <v-form ref="form" @submit.prevent="onEdit">
          <v-text-field
            v-model="password"
            append-icon="mdi-lock-outline"
            label="Password"
            type="password"
            autocomplete="disabled"
            :rules="[rules.required]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn class="ml-auto" color="#29284c" text :loading="loading" @click="dialog = false">
          Close
          <v-icon right> mdi-close </v-icon>
        </v-btn>
        <v-btn class="ml-2" dark color="#29284c" :loading="loading" @click="onEdit">
          Save
          <v-icon right> mdi-lock-outline </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { changeStudentPassword } from "@/api/api";
import rulesMixin from "@/mixins/rulesMixin";

export default {
  props: {
    user: Object,
  },
  mixins: [rulesMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      password: "",
    };
  },
  methods: {
    async onEdit() {
      try {
        this.loading = true;
        const response = await changeStudentPassword(this.user.uuid, this.password);
        if (response) this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
